import CloseSidePanels from 'actions/customer/close_side_panels';
import OpenCommentPanel from 'actions/task/open_comment_panel';
import { SidePanelType } from 'models/side_panel';

export default class ToggleSidePanels {
  constructor(context) {
    this.context = context;
  }

  run() {
    const sidePanel = this.context.stores.sidePanel.get();

    if (sidePanel.isShowing(SidePanelType.TASK)) {
      this.context.executeAction(CloseSidePanels);
      return;
    }

    const itemId = this.context.stores.commentPanel.get().selectedItemId;
    if (!itemId) {
      return;
    }

    this.context.executeAction(OpenCommentPanel, { itemId });
  }
}
